import React from 'react';
import Input from '../componenti/input/Simple';
import InputProv from '../componenti/input/Provincia';

const Certificazione = ({
    text_nato,
    text_cittadino,
    anteprima, 
    inputValues,
    handleOnChange,
    }) => {
    return (
        <>
            <div style={{padding:'20px'}}>DICHIARA</div>
            che il numero di PARTITA IVA, atttribuito alla ditta denominata
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='dittaDenominata'
            />
            con sede legale in
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='citIva'
            />
            <InputProv
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='provIva'
            />
            in
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='viaIva'
            />
            , n°
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='ncitIva'
            />
            è il seguente: 
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='nUffIva'
            />
        </>
        );
    }

export default Certificazione;